export const medical = {
    selectBtn: "specialist"
};


export const education = {
    teacher: [],
    msg: ""
};

export const auth = {
    user: null,
    userOwnedData: null
};

export const placedOrderState = {
    placedOrder: []
}